import type { DeviceState, HealthLevel, JobDeviceStatus, JobStatus, ReleaseStatus } from '../api';
import { Badge, type Tone } from './ui';

const deviceStates: Record<DeviceState, [Tone, string]> = {
  up_to_date: ['green', 'Up to date'],
  updating: ['blue', 'Updating'],
  failed: ['red', 'Update failed'],
  no_target: ['slate', 'No target'],
};

export function DeviceStateBadge({ state }: { state: DeviceState }) {
  const [tone, label] = deviceStates[state];
  return <Badge tone={tone}>{label}</Badge>;
}

const healthTones: Record<HealthLevel, Tone> = { ok: 'green', warning: 'amber', critical: 'red', unknown: 'slate' };

export function HealthBadge({ health }: { health: { level: HealthLevel; unexpected_reboots: number } | null }) {
  if (!health) return null;
  const label = health.level === 'unknown' ? 'No data' : health.level === 'ok' ? 'Stable' : `${health.unexpected_reboots} reboots`;
  const title =
    health.level === 'unknown'
      ? 'Firmware does not report a boot counter'
      : `${health.unexpected_reboots} unexpected reboots in the health window`;
  return (
    <Badge tone={healthTones[health.level]} title={title}>
      {label}
    </Badge>
  );
}

const releaseTones: Record<ReleaseStatus, Tone> = { active: 'green', deprecated: 'amber', blocked: 'red' };

export function ReleaseStatusBadge({ status }: { status: ReleaseStatus }) {
  return <Badge tone={releaseTones[status]}>{status}</Badge>;
}

const jobTones: Record<JobStatus | JobDeviceStatus, Tone> = {
  running: 'blue',
  paused: 'amber',
  completed: 'green',
  cancelled: 'slate',
  pending: 'slate',
  offered: 'blue',
  done: 'green',
  failed: 'red',
};

export function JobStatusBadge({ status }: { status: JobStatus | JobDeviceStatus }) {
  return <Badge tone={jobTones[status]}>{status}</Badge>;
}
